export default "__VITE_ASSET__4645db07__"